module.exports = __webpack_public_path__ + "img/badge_gray_hs-finaid.8a4925f6.svg";